<script lang="ts">
	import StrapiImage from './StrapiImage.svelte';
	import { trackLink } from './utils/mixpanel';

	async function getBannerAd(): Promise<BannerAd> {
		return fetch('/api/banner-ad').then((res) => {
			if (res.ok) {
				return res.json() as unknown as BannerAd;
			} else {
				throw new Error('Failed to fetch banner ad');
			}
		});
	}
</script>

{#await getBannerAd() then data}
	{#if data.iframeMediaDesktop}
		<div
			data-type="banner-ad"
			data-content={data.provider}
			class="element-visibility w-full max-w-screen-md"
		>
			<iframe
				title="Sponsor Banner"
				src={data.iframeMediaDesktop.src}
				height={`${data.iframeMediaDesktop.height}`}
				width={`${data.iframeMediaDesktop.width}`}
				class="mb-4"
			></iframe>
			<p class="card-bold mb-1">{data.adMessage}</p>
			<p class="small-regular text-gray-mid">
				<span class="small-bold">Ad</span> • {data.provider}
			</p>
		</div>
	{:else}
		<div class="w-full max-w-screen-md">
			<a
				onclick={trackLink}
				href={data.url}
				target="_blank"
				rel="noreferrer"
				class="element-visibility mb-4 flex justify-center"
				aria-label={data.provider}
				data-type="banner-ad"
				data-content={data.provider}
			>
				<StrapiImage
					cover={data.coverDesktop}
					alt={data.provider}
					class="hidden aspect-[3/1] w-full border-1 border-solid border-black md:block"
				/>
				<StrapiImage
					cover={data.coverMobile}
					alt={data.provider}
					class="block aspect-[6/5] w-full border-1 border-solid border-black md:hidden"
				/>
			</a>
			<p class="card-bold mb-1">{data.adMessage}</p>
			<p class="small-regular text-gray-mid">
				<span class="small-bold">Ad</span> • {data.provider}
			</p>
		</div>
	{/if}
{:catch}
	<div></div>
{/await}
